export const Styles = {
  historyContainer: {
    minWidth: '200px !important',
    '& > div:nth-of-type(1)': {
      height: '100%',
      width: 386,
    },
  },
  summaryHistoryBody: {
    paddingLeft: 0,
  },
  historyFooter: {
    justifyContent: 'center',
    height: 2,
  },
  title: {
    color: '#03234D',
    paddingLeft: 2,
    fontSize: 16,
    fontWeight: 700 
  },
  headerText: {
    fontSize: 16,
    fontWeight: 700, 
    lineHeight: '22px',
    color: '#03234D',
  },
  iconWrapper: {
    boxShadow: 'none',
    marginRight: 0,
  }
};
